"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.purifyText = exports.isColorDark = exports.default = exports.colorToAlphaHex = void 0;
var _lodashEs = require("lodash-es");
/**
 * Takes an HTML formatted string and removes the HTML tags, extra spaces and
 * return characters
 * @param {String} text
 * @return {String}
 */

const purifyText = function (text) {
  let keepExtraSpace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  const htmlExp = keepExtraSpace ? /(<([^>]+)>\*?)/gi : /(\s{1}<([^>]+)>\*?)/gi;
  const extraCharsExp = /[\r\n|\n\r]\s{2,}/gm;
  const response = text === null || text === void 0 ? void 0 : text.trim().replace(htmlExp, "").replace(extraCharsExp, " ");
  return (0, _lodashEs.unescape)(response);
};

/**
 * Receives an hex, rgb, or rgba color and applies a opacity value
 *
 * @param {string} color HEX, RGB, OR RGBA color
 * @param {number} opacity transparency value between 0 and 1
 * @returns hex color with alpha value
 */
exports.purifyText = purifyText;
const colorToAlphaHex = function (color, opacity) {
  if (!color || opacity === undefined || typeof color !== "string") return color;
  let hexColor = color.replace(/^#/, "");
  const opacityValue = typeof opacity === "string" ? Number.parseFloat(opacity) : opacity || 1;

  // HEX support
  if (/^([A-Fa-f0-9]{3}|[A-Fa-f0-9]{6})$/.test(hexColor)) {
    hexColor = hexColor.replace(/^#/, "");

    // Convert 3-digit hex to 6-digit hex
    if (hexColor.length === 3) {
      hexColor = hexColor.split("").map(function (char) {
        return char + char;
      }).join("");
    }
  }
  // RGBA support
  else if (/^rgba?\((\d+),\s*(\d+),\s*(\d+)(,\s*([01]?(?:\.\d+)?))?\)$/.test(hexColor)) {
    var _hexColor$match;
    const rgbValues = (_hexColor$match = hexColor.match(/\d+(\.\d+)?/g)) === null || _hexColor$match === void 0 ? void 0 : _hexColor$match.map(Number);
    if (!rgbValues || rgbValues.length < 3) return null;
    const [r, g, b] = rgbValues;
    hexColor = [r, g, b].map(function (val) {
      return val.toString(16).padStart(2, "0");
    }).join("");
  } else {
    return color;
  }
  if (typeof opacityValue !== "number" || Number.isNaN(opacityValue) || opacityValue < 0 || opacityValue >= 1) {
    return color;
  }
  if (opacityValue === 0) {
    return "transparent";
  }
  const alpha = Math.round(opacityValue * 255).toString(16).padStart(2, "0");
  return `#${hexColor}${alpha}`;
};

/**
 * Determines if a given color (hex, hex with alpha, or RGBA) is dark based on luminance.
 *
 * @param {string} color - Color code in hex, hex with alpha, or RGBA format.
 * @returns {boolean} - True if the color is dark, false if light.
 */
exports.colorToAlphaHex = colorToAlphaHex;
const isColorDark = function (color) {
  let r;
  let g;
  let b;
  if (!color || typeof color !== "string") return false;

  // HEX support
  if (color.startsWith("#")) {
    let newColor = color.slice(1);
    if (newColor.length === 3) {
      newColor = newColor.split("").map(function (char) {
        return char + char;
      }).join("");
    } else if (newColor.length === 8) {
      newColor = newColor.slice(0, 6);
    } else if (newColor.length !== 6) {
      throw new Error("Invalid hex color format");
    }
    r = Number.parseInt(newColor.slice(0, 2), 16);
    g = Number.parseInt(newColor.slice(2, 4), 16);
    b = Number.parseInt(newColor.slice(4, 6), 16);
  }
  // RGBA support
  else if (color.startsWith("rgba")) {
    const rgbaMatch = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+),?\s*([\d.]*)\)/);
    if (!rgbaMatch) throw new Error("Invalid RGBA format");
    r = Number.parseInt(rgbaMatch[1], 10);
    g = Number.parseInt(rgbaMatch[2], 10);
    b = Number.parseInt(rgbaMatch[3], 10);
  } else {
    console.log("Invalid color format");
    return false;
  }
  const luminance = r * 0.299 + g * 0.587 + b * 0.114;

  // Return true if luminance is less than or equal to 186 (threshold for dark color)
  return luminance <= 186;
};
exports.isColorDark = isColorDark;
var _default = exports.default = {
  purifyText,
  colorToAlphaHex,
  isColorDark
};